import AnnouncementBar from "@/components/feature/AnnouncementBar";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import Hero from "./components/Hero";
import IntroSection from "./components/IntroSection";
import FeaturedProducts from "./components/FeaturedProducts";
import FeatureTextSection from "./components/FeatureTextSection";
import ShopTheLook from "./components/ShopTheLook";
import StoryHero from "./components/StoryHero";
import InstagramSection from "./components/InstagramSection";

export default function Home() {
  return (
    <div className="w-full min-h-screen bg-background-50">
      <AnnouncementBar />
      <Navbar />
      <main>
        <Hero />
        <IntroSection />
        <FeaturedProducts />
        <FeatureTextSection
          id="custom"
          image="https://sofiajewelry.com/cdn/shop/files/CCSept-15.jpg?v=1775503819"
          imageAlt="Model wearing layered gold jewelry for summer"
          imageSide="right"
          heading="Summer Sparkle"
          description="Celebrate the season with jewelry that shines as brightly as summer days. From effortless everyday pieces to statement styles perfect for vacations, weddings, and special occasions, our curated collection is designed to add a touch of sparkle to every moment. Discover timeless pieces you'll love all season long and beyond."
          linkLabel="Shop Here"
          linkHref="#featured"
        />
        <FeatureTextSection
          image="https://sofiajewelry.com/cdn/shop/files/DSC_2525_33e6f0e9-34bb-4d75-af30-d57047bcba43.jpg?v=1731924218"
          imageAlt="Jeweler designing a bespoke custom creation"
          imageSide="left"
          subHeading="Custom Creations"
          heading="Create Your Own Style"
          description="Custom jewelry at Sofia Jewelry is where your story takes shape. From initial sketch to final setting, each piece is thoughtfully designed and expertly crafted to reflect your personal style. Whether reimagining heirlooms or creating something entirely new, we bring meaning, artistry, and precision to every detail — resulting in one-of-a-kind pieces made to be worn and treasured for a lifetime."
          linkLabel="Start Here"
          linkHref="#contact"
          tinted
        />
        <FeatureTextSection
          image="https://sofiajewelry.com/cdn/shop/files/Yellow_Diamond_Bracelets_1.jpg?v=1774499726"
          imageAlt="Yellow diamond bracelets by Sofia Jewelry designers"
          imageSide="right"
          heading="Timeless Masterpieces"
          description="From the intricate designs to the flawless craftsmanship, all of the jewelry offered at Sofia Jewelry is handcrafted by skilled artisans who take great pride to create pieces that are of the highest quality. From the Sofia Jewelry Collection, to our curated designers, Sethi Couture, Suneera, Imperfect Grace, Alex Sepkus, Campbell + Charlotte, Moritz Glik, Dilamani, Suzanne Kalan, DSL and more. The quality of our diamonds, gemstones and artists are never compromised at Sofia Jewelry."
          linkLabel="Shop Our Designers"
          linkHref="#featured"
        />
        <ShopTheLook />
        <StoryHero />
        <InstagramSection />
      </main>
      <Footer />
    </div>
  );
}